<op-query-filters *ngIf="!!filters"
               (filtersChanged)="filters = $event"
               [filters]="filters"></op-query-filters>
